<template>
    <div>
        <div class="index_top" v-show="topindex == 0">
              <div class="logo">
                  <img src="~@/assets/logo.png" alt="logo">
              </div>
              <div class="option">
                  <div class="list active" @click="goTo('/')">
                      <div class="zh">首页</div>
                      <div class="en">HOME</div>
                  </div>
                  <div class="list" @click="goTo('category?url=category')">案例展示</div>
                  

                  <div class="list" @click="goTo('add_order?url=add_order')">方案定制</div>
                  <div class="list" @click="goTo('news?url=news&sid=0')">新闻中心</div>
                  <div class="list" @click="goTo('about_us?url=about_us')">联系我们</div>
                  <div class="list" @click="goTo('help?url=help')">帮助中心</div>

              </div>
              <div class="phone">
                  <div class="world">
                      <div class="title">免费服务热线</div>
                      <div class="number">180-2211-8773</div>
                  </div>
                  <img src="~@/assets/phone.png">
              </div>
          </div>

          <div class="index_top index_fixe" v-show="topindex == 1">
              <div class="logo">
                  <img src="~@/assets/logo2.png" alt="logo">
              </div>
              <div class="option">
                  <div class="list active" @click="goTo('/')">
                      <div class="zh">首页</div>
                      <div class="en">HOME</div>
                  </div>
                  <div class="list" @click="goTo('category?url=category')">案例展示</div>
                  

                  <div class="list" @click="goTo('add_order?url=add_order')">方案定制</div>
                  <div class="list" @click="goTo('news?url=news&sid=0')">新闻中心</div>
                  <div class="list" @click="goTo('about_us?url=about_us')">联系我们</div>
                  <div class="list" @click="goTo('help?url=help')">帮助中心</div>

              </div>
              <div class="phone">
                  <div class="world">
                      <div class="title">免费服务热线</div>
                      <div class="number">180-2211-8773</div>
                  </div>
                  <img src="~@/assets/phone.png">
              </div>
          </div>
    </div>
</template>
      
<script>
export default {
  name: 'top',
  components: {
      
  },
  data () {
    return {
       topindex:0
    }
  },
  mounted () {
        window.addEventListener('scroll', this.windowScroll)
  },
  methods:{
      windowScroll() {
      // 滚动条距离页面顶部的距离
      // 以下写法原生兼容
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      
      if(scrollTop > 400){
          this.topindex = 1
      }else{
          this.topindex = 0
      }
    },
    goTo(url){
        this.$router.push(url);
    }
  },
  destroyed(){
    window.removeEventListener('scroll',this.handleScroll)
  }
}
</script>

<style lang='scss' scoped>
$zycolor:#CF2C2E;
.index_top{
  position:absolute;
  top:0;
  left: 0;
  z-index: 10;
  height: 100px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .logo{
    width: 20%;
    height: 112px;
    display: flex;
    justify-content: center;
    align-items: center;
    img{
      width: 244px;
      height: 50px;
    }
  }
  .option{
    width:  60%;
    height: 100px;
    display: flex;
    align-items: center;
    .list{
      // width: 100px;
      padding:0 30px;
      height: 50px;
      // background: $zycolor;
      color: #fff;
      margin-right: 10px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      cursor: pointer;
      .en{
        font-size: 12px;
        margin-top:4px;
      }
    }
    .list:hover{
       background: $zycolor;
    }
    .active{
      background: $zycolor;
    }
  }
  .phone{
    width: 20%;
    height: 100px;
    display: flex;
    justify-content: center;
    align-items: center;
    .world{
      margin-right:10px;
      height: 50px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      text-align: right;
      .number{
        font-size: 24px;
        font-weight: bold;
        color:$zycolor;
      }
    }
    img{
      width: 50px;
      height: 50px;
    }
  }
}
.index_fixe{
  position: fixed;
  top:0;
  left: 0;
  background: #fff;
  z-index: 120;
  border-bottom: 1px solid #eee;
  .option .list{
      color: #222;
  }
  .option .active{
      color: #fff;
  }
  .list:hover{
     background: $zycolor;
     color:#fff;
  }
}
</style>